import script from "./ValuesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ValuesSection.vue?vue&type=script&setup=true&lang=js"

import "./ValuesSection.vue?vue&type=style&index=0&id=102c1024&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-102c1024"]])

export default __exports__